import { CognitoUserPoolsTokenProvider } from './CognitoUserPoolsTokenProvider.mjs';

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * The default provider for the JWT access token and ID token issued from the configured Cognito user pool. It manages
 * the refresh and storage of the tokens. It stores the tokens in `window.localStorage` if available, and falls back to
 * in-memory storage if not.
 */
const cognitoUserPoolsTokenProvider = new CognitoUserPoolsTokenProvider();
const {
  tokenOrchestrator
} = cognitoUserPoolsTokenProvider;
export { cognitoUserPoolsTokenProvider, tokenOrchestrator };
